import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-viewport-closable-widget",
  "use": "foquz-icon-viewport-closable-widget-usage",
  "viewBox": "0 0 19 19",
  "content": "<symbol viewBox=\"0 0 19 19\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-viewport-closable-widget\"><path d=\"M11.5 7.499l3-3m-3 0l3 3m-13 9.068V2.57a1 1 0 011-1h14a1 1 0 011 1v13.936a1 1 0 01-.997 1l-14 .06a1 1 0 01-1.003-1z\" stroke=\"currentColor\" stroke-width=\"2\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol